import { Box } from '@dixa/lib-shared-habla';

import { presenceApi } from 'apis/presence';
import { LegacyPresenceListSections } from 'components/presence/components/legacyPresenceListSections';
import { PresenceListSections } from 'components/presence/components/presenceListSections';
import { PresenceSectionWarning } from 'components/presence/components/presenceSectionWarning';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { useCurrentUser } from 'utils/user';

import styles from './presenceList.module.scss';

export const PresenceList = (): JSX.Element => {
  const { user } = useCurrentUser();
  const presence = useAppSelector((state) => state.presence);
  const flags = useFeatureFlag([
    'custom-away-status',
    'legacy-presence-sidebar',
  ]);

  const { awayStatuses } = presenceApi.useReadAwayStatusesQuery(
    { isDeactivated: false },
    {
      skip: !flags.customAwayStatus,
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        awayStatuses: data?.data.customAwayStatuses ?? [],
      }),
    },
  );

  const isOffline = presence.meta.offline;
  const hasFailed =
    presence.allPresence.length === 0 &&
    presence.meta.getAsyncStatus === 'failed';

  return (
    <Box padding="0 200">
      <ul className={styles.list}>
        {hasFailed ? (
          <PresenceSectionWarning title="Presence loading failed.." />
        ) : isOffline ? (
          <PresenceSectionWarning title="You are offline" />
        ) : flags.legacyPresenceSidebar ? (
          <LegacyPresenceListSections
            presence={presence}
            presenceAsyncStatus={presence.meta.getAsyncStatus}
            profile={user}
            awayStatuses={awayStatuses}
          />
        ) : (
          <PresenceListSections profile={user} awayStatuses={awayStatuses} />
        )}
      </ul>
    </Box>
  );
};
